import { render, staticRenderFns } from "./studentsEditDataMedical.vue?vue&type=template&id=107bf8f7&scoped=true&"
import script from "./studentsEditDataMedical.vue?vue&type=script&lang=js&"
export * from "./studentsEditDataMedical.vue?vue&type=script&lang=js&"
import style0 from "./studentsEditDataMedical.vue?vue&type=style&index=0&id=107bf8f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107bf8f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCardText,VCheckbox,VCol,VFadeTransition,VIcon,VProgressCircular,VRow,VTabItem,VTextField,VTextarea})
